// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./MamahoodHeroTitle.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./homepageV2Foundation.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./homepageV2SectionPolish.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/static/img/IMAGES/BANNERS/homepage_banner_mobile.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * HomePage V2 — styles mirrored from MamahoodHomepage.css (mh2v2- prefix).
 * Keeps production HomePage.css / MamahoodHomepage.css untouched.
 */

.mh2v2-hero__title,
.mh2v2-now-card__overlay h4,
.mh2v2-program-card__overlay h4,
.mh2v2-testimonial__content h4,
.mh2v2-category-card__overlay h5,
.mh2v2-collective-info h4,
.mh2v2-about-founder__caption h4,
.mh2v2-membership-tier h4 {
  font-family: fabulosa, sans-serif;
}

.mh2v2-hero__title {
  font-style: normal;
  font-weight: 400;
  font-size: clamp(3rem, 6vw, 5.5rem);
  line-height: 0.95;
  color: rgba(255, 255, 255, 0.92);
  margin: 0 0 26px;
  text-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
  text-transform: none;
  letter-spacing: normal;
}

.mh2v2-hero__title::first-letter {
  font-feature-settings: "init" 1;
}

.mh2v2-program-card.mustard .mh2v2-program-card__overlay {
  background: #d59d55;
}

.mh2v2-program-card.coral .mh2v2-program-card__overlay {
  background: var(--coral);
}

.mh2v2-program-card.pink .mh2v2-program-card__overlay {
  background: var(--pink);
}

a.mh2v2-happening-card {
  text-decoration: none;
  color: #fff;
}

.mh2v2-founder-panel > a {
  display: block;
}

.mh2v2-founder-panel > a img {
  width: 100%;
}

.mh2v2-page {
  width: 100%;
  overflow-x: hidden;
}

.mh2v2-section-light {
  background: var(--light);
}

.mh2v2-section-cream {
  background: var(--cream);
}

.mh2v2-section-mustard {
  background: #d5b95a;
}

.mh2v2-section-charcoal {
  background: var(--charcoal);
}

/* Typography roles: see homepageV2Foundation.css */

.mh2v2-section-title--center {
  text-align: center;
}

.mh2v2-section-title--light {
  color: var(--white);
}

.mh2v2-script,
.mh2v2-now-card__overlay h4,
.mh2v2-program-card__overlay h4,
.mh2v2-testimonial__content h4,
.mh2v2-category-card__overlay h5,
.mh2v2-collective-info h4,
.mh2v2-about-founder__caption h4,
.mh2v2-membership-tier h4 {
  font-family: var(--mh-font-display);
  font-weight: 400;
}

.mh2v2-script {
  color: #de7d86;
  text-align: center;
  font-size: clamp(2rem, 4vw, 3.6rem);
  line-height: 1.08;
  max-width: 950px;
  margin: 0 auto 14px;
}

.mh2v2-copy--center {
  text-align: center;
  max-width: 820px;
  margin: 0 auto;
}

.mh2v2-pill {
  border: none;
  border-radius: 999px;
  padding: 13px 26px;
  cursor: pointer;
  background: var(--gold);
  color: #fff;
  font-weight: 700;
  box-shadow: var(--shadow);
  transition:
    transform var(--transition-base),
    box-shadow var(--transition-base),
    color var(--transition-fast);
}

.mh2v2-pill:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-hover);
}

.mh2v2-pill:active {
  transform: translateY(0);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.mh2v2-pill:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
}

.mh2v2-pill--small {
  padding: 10px 18px;
  font-size: 0.9rem;
}

.mh2v2-pill--region {
  min-width: 220px;
  color: #fff;
  box-shadow: none;
  transition: transform var(--transition-base), opacity var(--transition-fast);
}

.mh2v2-pill--region:hover {
  transform: translateY(-2px);
  opacity: 0.95;
}

.mh2v2-pill--region:active {
  transform: translateY(0);
}

.mh2v2-pill--region:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
}

.mh2v2-pill--gold {
  background: var(--gold);
  color: #fff;
}

a.mh2v2-pill,
a.mh2v2-inline-btn,
a.mh2v2-category-link {
  text-decoration: none;
  display: inline-block;
  text-align: center;
}

.mh2v2-page .coral {
  background: var(--coral);
}

.mh2v2-page .mustard {
  background: #d59d55;
}

.mh2v2-page .pink {
  background: var(--pink);
}

.mh2v2-page .teal {
  background: var(--teal);
}

.mh2v2-page .salmon {
  background: var(--salmon);
}

.mh2v2-page .mint {
  background: var(--mint);
}

.mh2v2-teal-text {
  color: var(--teal);
}

.mh2v2-inline-btn {
  border: none;
  background: #ef8b6a;
  color: white;
  border-radius: 999px;
  padding: 8px 14px;
  font-size: 0.86rem;
  font-weight: 700;
  cursor: pointer;
  transition:
    transform var(--transition-fast),
    opacity var(--transition-fast),
    background-color var(--transition-fast);
}

.mh2v2-inline-btn:hover {
  transform: translateY(-1px);
  opacity: 0.95;
  background-color: #e87a58;
}

.mh2v2-inline-btn:active {
  transform: translateY(0);
}

.mh2v2-inline-btn:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
}

.mh2v2-link-row {
  display: block;
  text-align: center;
  font-weight: 700;
  color: var(--text);
  transition: color var(--transition-fast);
}

.mh2v2-link-row:hover {
  color: var(--teal);
}

.mh2v2-link-row:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
  border-radius: 2px;
}

.mh2v2-link-row--light {
  color: var(--white);
}

.mh2v2-link-row--light:hover {
  color: rgba(255, 255, 255, 0.9);
}

/* Header / nav: see components/navigation/MamahoodMarketingHeader.css */

/* Hero */
.mh2v2-hero {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  padding: var(--mh2-space-2xl) var(--mh2-container-gutter);
  min-height: 620px;

  background: #d9e6e3 url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center / cover no-repeat;

  display: flex;
  align-items: center;
}

.mh2v2-hero__overlay {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  text-align: center;
  padding: 32px;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.08));
}

/* .mh2v2-hero__title: see MamahoodHeroTitle.css */

.mh2v2-region-row {
  margin-top: var(--mh2-gap-lg);
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
}

.mh2v2-happening-grid {
  margin-top: var(--mh2-space-xl);
  display: grid;
  grid-template-columns: 1.3fr 0.9fr;
  align-items: start;
}

.mh2v2-happening-list {
  display: grid;
}

.mh2v2-happening-card {
  display: grid;
  grid-template-columns: 56px 1fr 48px;
  gap: var(--mh2-space-md);
  align-items: center;
  padding: var(--mh2-space-md) var(--mh2-space-md);
  color: #fff;
}

.mh2v2-happening-card:focus-within {
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
}

.mh2v2-happening-card__icon {
  font-size: 1.5rem;
  text-align: center;
}

.mh2v2-happening-card__body h4 {
  margin: 0 0 4px;
  font-size: 1.15rem;
}

.mh2v2-happening-card__body p {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.4;
}

.mh2v2-happening-card__arrow {
  justify-self: end;
  width: 36px;
  height: 36px;
  border: 1px solid rgba(255, 255, 255, 0.75);
  border-radius: 50%;
  display: grid;
  place-items: center;
  font-size: 1.1rem;
  transition: transform var(--transition-fast);
}

.mh2v2-happening-card:hover .mh2v2-happening-card__arrow {
  transform: translateX(3px);
}

.mh2v2-membership-box {
  background: #fff;
  border-radius: var(--mh2-card-radius-lg);
  padding: var(--mh2-space-lg) var(--mh2-space-lg) var(--mh2-gap-lg);
}

.mh2v2-membership-box:hover {
  box-shadow: var(--shadow-hover);
}

.mh2v2-membership-tier {
  text-align: center;
}

.mh2v2-membership-tier h4 {
  font-size: 2rem;
  margin: 16px 0 10px;
  line-height: 1;
}

.mh2v2-membership-tier p {
  margin: 0 auto 16px;
  color: var(--muted);
  max-width: 320px;
  line-height: 1.5;
}

.mh2v2-membership-divider {
  height: 1px;
  background: #ddd;
  margin: 24px 0;
}

.mh2v2-round-logo {
  width: 78px;
  height: 78px;
  margin: 0 auto;
  border-radius: 50%;
  background: var(--mint);
  color: #fff;
  display: grid;
  place-items: center;
  font-family: var(--mh-font-display);
  font-size: 2rem;
  font-weight: 400;
}

.mh2v2-round-logo--small {
  font-size: 1.2rem;
}

.mh2v2-round-logo--xl {
  width: 102px;
  height: 102px;
  font-size: 1.5rem;
}

.mh2v2-story-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.mh2v2-story-card {
  background: #fff4df;
  overflow: hidden;
}

.mh2v2-story-card img {
  height: 190px;
}

.mh2v2-story-card:hover img {
  transform: scale(1.03);
}

.mh2v2-story-card__content {
  padding: var(--mh2-card-padding);
  display: flex;
  justify-content: space-between;
  gap: var(--mh2-gap-sm);
  align-items: center;
}

.mh2v2-story-card__content p {
  margin: 0;
  font-size: 0.96rem;
  line-height: 1.35;
}

/* Now */
.mh2v2-now-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.mh2v2-now-card {
  overflow: hidden;
  position: relative;
  min-height: 430px;
}

.mh2v2-now-card img {
  height: 430px;
}

.mh2v2-now-card:hover img {
  transform: scale(1.04);
}

.mh2v2-now-card__overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(111, 159, 154, 0.85), rgba(0, 0, 0, 0.1));
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: var(--mh2-space-lg);
}

.mh2v2-now-card__overlay h4 {
  font-size: 3rem;
  line-height: 0.9;
  margin: 0 0 18px;
}

.mh2v2-now-card__footer {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 14px;
}

.mh2v2-now-card__footer p {
  margin: 0;
  font-size: 0.95rem;
  max-width: 200px;
}

.mh2v2-program-list {
  display: grid;
}

.mh2v2-program-card {
  --program-image-position: 50% 40%;
  --program-image-scale: 1;

  position: relative;
  min-height: 260px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.mh2v2-program-card__media {
  position: relative;
  height: 150px;
  overflow: hidden;
}

.mh2v2-program-card__media img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: var(--program-image-position);
  transform: scale(var(--program-image-scale));
}

.mh2v2-program-card__overlay {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 22px 28px;
  text-align: center;
  color: white;
}

.mh2v2-program-card__overlay h4 {
  font-size: clamp(2.2rem, 4vw, 4.6rem);
  line-height: 0.9;
  margin: 0;
  text-shadow: 0 4px 18px rgba(0, 0, 0, 0.2);
}

.mh2v2-program-card__overlay p {
  margin: var(--mh2-space-sm) 0 0;
  font-size: var(--mh2-size-body-sm);
  max-width: 760px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.mh2v2-testimonial-list {
  display: grid;
}

.mh2v2-testimonial {
  --testimonial-image-position: 50% 40%;
  --testimonial-image-scale: 1;

  display: grid;
  grid-template-columns: 1fr 1.45fr;
  overflow: hidden;
  background: white;
}

.mh2v2-testimonial.reverse {
  grid-template-columns: 1.45fr 1fr;
}

.mh2v2-testimonial.reverse .mh2v2-testimonial__media {
  order: 2;
}

.mh2v2-testimonial__media {
  position: relative;
  height: 100%;
  min-height: 330px;
  overflow: hidden;
}

.mh2v2-testimonial__media img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: var(--testimonial-image-position);
  transform: scale(var(--testimonial-image-scale));
  transform-origin: center center;
  transition: transform var(--transition-slow);
}

.mh2v2-testimonial:hover .mh2v2-testimonial__media img {
  transform: scale(calc(var(--testimonial-image-scale) * 1.02));
}

.mh2v2-testimonial__content {
  padding: var(--mh2-space-xl) var(--mh2-space-lg);
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.mh2v2-testimonial__content.teal {
  background: var(--teal);
}

.mh2v2-testimonial__content.mustard {
  background: #d3b357;
  color: #2f2b2f;
}

.mh2v2-testimonial__content.coral {
  background: var(--coral);
}

.mh2v2-testimonial__content h4 {
  font-size: clamp(2rem, 3.3vw, 3.2rem);
  line-height: 1;
  margin: 0 0 18px;
}

.mh2v2-testimonial__content p {
  font-size: var(--mh2-size-body);
  line-height: var(--mh2-line-body);
  margin: 0 0 var(--mh2-gap-sm);
  opacity: 0.95;
}

.mh2v2-testimonial__content strong,
.mh2v2-testimonial__content span {
  display: block;
  font-size: 1.2rem;
  margin-top: 4px;
}

/* M List */
.mh2v2-mlist-hero {
  position: relative;
  min-height: 260px;
}

.mh2v2-mlist-hero__badge {
  position: absolute;
  right: 60px;
  top: 24px;
  width: 220px;
  height: 220px;
  border: 3px dashed rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  color: white;
  display: grid;
  place-items: center;
  font-family: var(--mh-font-display);
  font-size: 2rem;
  background: rgba(151, 112, 72, 0.45);
}

.mh2v2-center-actions {
  display: flex;
  justify-content: center;
  gap: 14px;
  flex-wrap: wrap;
  margin: 18px 0 28px;
}

.mh2v2-category-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.mh2v2-category-card {
  background: white;
  overflow: hidden;
}

.mh2v2-category-card img {
  height: 240px;
}

.mh2v2-category-card:hover img {
  transform: scale(1.03);
}

.mh2v2-category-card__overlay {
  position: relative;
  margin-top: -120px;
  color: #fff;
  padding: var(--mh2-space-lg) var(--mh2-space-md);
  min-height: 120px;
  background: var(--mh2-overlay-gradient);
}

.mh2v2-category-card__overlay h5 {
  font-size: 3rem;
  line-height: 0.88;
  margin: 0 0 14px;
}

.mh2v2-category-links {
  display: grid;
  gap: 10px;
  padding: 16px 14px 18px;
}

.mh2v2-category-link {
  border: none;
  border-radius: 999px;
  padding: 12px 16px;
  background: var(--gold);
  color: white;
  font-weight: 700;
  cursor: pointer;
  transition: transform var(--transition-fast), box-shadow var(--transition-fast);
}

.mh2v2-category-link:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow);
}

.mh2v2-category-link:active {
  transform: translateY(0);
}

.mh2v2-category-link:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
}

/* Collective */
.mh2v2-collective-grid {
  display: grid;
  grid-template-columns: 1fr 1.15fr;
  align-items: start;
}

.mh2v2-collective-info h4 {
  font-size: clamp(2.2rem, 4vw, 4rem);
  line-height: 0.9;
  margin: 0 0 18px;
  max-width: 540px;
}

.mh2v2-collective-info p {
  font-size: 1.05rem;
  line-height: 1.6;
  color: var(--muted);
  max-width: 430px;
}

.mh2v2-quote-chip {
  background: var(--mint);
  color: white;
  border-radius: 24px;
  padding: 24px 26px;
  margin: 28px 0 0;
  font-size: 1.6rem;
  font-family: var(--mh-font-display);
  line-height: 1.1;
}

.mh2v2-quote-chip span {
  display: block;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 0.95rem;
  margin-top: 10px;
}

.mh2v2-founder-panel {
  background: var(--cream);
  border-radius: var(--mh2-card-radius-lg);
  padding: var(--mh2-space-lg);
}

.mh2v2-founder-panel img {
  height: 360px;
}

.mh2v2-founder-panel__body {
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 18px;
  padding: 18px 4px 6px;
}

.mh2v2-founder-brand {
  font-size: 2rem;
  font-family: var(--mh-font-display);
}

.mh2v2-founder-panel__body h5 {
  font-size: 2.2rem;
  margin: 0 0 8px;
  font-family: var(--mh-font-display);
}

.mh2v2-founder-panel__body p {
  margin: 0 0 8px;
  line-height: 1.5;
  color: var(--muted);
}

/* About */
.mh2v2-about-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
}

.mh2v2-about-founder img {
  height: 420px;
}

.mh2v2-about-founder__caption {
  text-align: center;
  color: #fff;
  margin-top: -70px;
  position: relative;
  z-index: 1;
  padding-bottom: 20px;
}

.mh2v2-about-founder__caption h4 {
  font-size: 2.5rem;
  margin: 0 0 6px;
}

.mh2v2-about-founder__caption p {
  margin: 0;
  color: rgba(255, 255, 255, 0.85);
}

.mh2v2-region-row--compact {
  margin-top: 8px;
}

.mh2v2-region-row--compact .mh2v2-pill--region {
  min-width: 180px;
  font-size: 0.85rem;
}

.mh2v2-about-copy {
  color: #fff;
}

.mh2v2-about-copy p {
  line-height: var(--mh2-line-body);
  color: rgba(255, 255, 255, 0.9);
  font-size: var(--mh2-size-body);
}

/* Footer */
.mh2v2-footer {
  background: #f3f1ef;
  padding: 36px 0 50px;
}

.mh2v2-footer__grid {
  display: grid;
  grid-template-columns: 1fr auto 1.2fr;
  align-items: start;
}

.mh2v2-footer__links {
  display: grid;
  gap: 10px;
  text-transform: uppercase;
  font-size: 0.84rem;
  letter-spacing: 0.08em;
  font-weight: 700;
}

.mh2v2-footer__links a {
  color: var(--text);
  text-decoration: none;
  transition: color var(--transition-fast);
}

.mh2v2-footer__links a:hover {
  color: var(--teal);
}

.mh2v2-footer__links a:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
  border-radius: 2px;
}

.mh2v2-footer__brand {
  display: grid;
  justify-items: center;
  gap: 12px;
}

.mh2v2-newsletter h4 {
  margin: 0 0 12px;
  letter-spacing: 0.18em;
  font-size: 0.95rem;
  text-transform: uppercase;
}

.mh2v2-newsletter__row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.mh2v2-newsletter input {
  width: 100%;
  padding: 12px 14px;
  margin-bottom: 12px;
  border: 1px solid #cfc6bf;
  background: #fff;
}

/* Reduced motion */
@media (prefers-reduced-motion: reduce) {
  .mh2v2-pill,
  .mh2v2-pill--region,
  .mh2v2-inline-btn,
  .mh2v2-happening-card,
  .mh2v2-happening-card__arrow,
  .mh2v2-story-card,
  .mh2v2-story-card img,
  .mh2v2-now-card,
  .mh2v2-now-card img,
  .mh2v2-program-card,
  .mh2v2-program-card__media img,
  .mh2v2-testimonial,
  .mh2v2-testimonial__media img,
  .mh2v2-category-card,
  .mh2v2-category-card img,
  .mh2v2-category-link,
  .mh2v2-membership-box,
  .mh2v2-socials span {
    transition: none;
  }

  .mh2v2-pill:hover,
  .mh2v2-pill--region:hover,
  .mh2v2-inline-btn:hover,
  .mh2v2-happening-card:hover,
  .mh2v2-story-card:hover,
  .mh2v2-now-card:hover,
  .mh2v2-program-card:hover,
  .mh2v2-testimonial:hover,
  .mh2v2-category-card:hover,
  .mh2v2-category-link:hover,
  .mh2v2-socials span:hover {
    transform: none;
  }

  .mh2v2-happening-card:hover .mh2v2-happening-card__arrow {
    transform: none;
  }

  .mh2v2-story-card:hover img,
  .mh2v2-now-card:hover img,
  .mh2v2-program-card:hover .mh2v2-program-card__media img,
  .mh2v2-category-card:hover img,
  .mh2v2-testimonial:hover .mh2v2-testimonial__media img {
    transform: none;
  }
}

/* Responsive */
@media (max-width: 1100px) {
  .mh2v2-happening-grid,
  .mh2v2-collective-grid,
  .mh2v2-about-grid,
  .mh2v2-footer__grid {
    grid-template-columns: 1fr;
  }

  .mh2v2-story-grid,
  .mh2v2-now-grid,
  .mh2v2-category-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .mh2v2-testimonial,
  .mh2v2-testimonial.reverse {
    grid-template-columns: 1fr;
  }

  .mh2v2-testimonial.reverse .mh2v2-testimonial__media {
    order: 0;
  }
}

@media (max-width: 768px) {
  .mh2v2-hero {
    min-height: 480px;
    height: 480px;
  }

  .mh2v2-story-grid,
  .mh2v2-now-grid,
  .mh2v2-category-grid,
  .mh2v2-newsletter__row,
  .mh2v2-founder-panel__body {
    grid-template-columns: 1fr;
  }

  .mh2v2-category-card__overlay h5,
  .mh2v2-now-card__overlay h4,
  .mh2v2-testimonial__content h4,
  .mh2v2-collective-info h4 {
    font-size: 2.2rem;
  }

  .mh2v2-program-card__overlay h4 {
    font-size: 2rem;
  }

  .mh2v2-mlist-hero__badge {
    width: 150px;
    height: 150px;
    right: 18px;
    top: 18px;
    font-size: 1.3rem;
  }

}`, "",{"version":3,"sources":["webpack://./src/components/twentytwentysix/styles/HomePageV2.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAKF;;;;;;;;EAQE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,2CAA2C;EAC3C,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,mDAAmD;;AAEnD;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;;;EAQE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB;;;gCAG8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,4EAA4E;AAC9E;;AAEA;EACE,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;;;EAGE,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf;;;2CAGyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,wEAAwE;;AAExE,SAAS;AACT;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,yDAAyD;EACzD,iBAAiB;;EAEjB,oFAAyG;;EAEzG,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,4FAA4F;AAC9F;;AAEA,kDAAkD;;AAElD;EACE,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,wBAAwB;EACxB,mBAAmB;EACnB,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,kEAAkE;AACpE;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kFAAkF;EAClF,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;;EAExB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,8CAA8C;EAC9C,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,SAAS;EACT,0CAA0C;AAC5C;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;;EAE5B,aAAa;EACb,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kDAAkD;EAClD,gDAAgD;EAChD,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,gDAAgD;EAChD,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,6BAA6B;EAC7B,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gDAAgD;EAChD,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,+EAA+E;AACjF;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA,eAAe;AACf;EACE,aAAa;EACb,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE;;;;;;;;;;;;;;;;;;IAkBE,gBAAgB;EAClB;;EAEA;;;;;;;;;;;IAWE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;;IAKE,eAAe;EACjB;AACF;;AAEA,eAAe;AACf;EACE;;;;IAIE,0BAA0B;EAC5B;;EAEA;;;IAGE,qCAAqC;EACvC;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;;;;;IAKE,0BAA0B;EAC5B;;EAEA;;;;IAIE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,WAAW;IACX,SAAS;IACT,iBAAiB;EACnB;;AAEF","sourcesContent":["/*\n * HomePage V2 — styles mirrored from MamahoodHomepage.css (mh2v2- prefix).\n * Keeps production HomePage.css / MamahoodHomepage.css untouched.\n */\n@import \"./MamahoodHeroTitle.css\";\n@import \"./homepageV2Foundation.css\";\n@import \"./homepageV2SectionPolish.css\";\n\n.mh2v2-hero__title,\n.mh2v2-now-card__overlay h4,\n.mh2v2-program-card__overlay h4,\n.mh2v2-testimonial__content h4,\n.mh2v2-category-card__overlay h5,\n.mh2v2-collective-info h4,\n.mh2v2-about-founder__caption h4,\n.mh2v2-membership-tier h4 {\n  font-family: fabulosa, sans-serif;\n}\n\n.mh2v2-hero__title {\n  font-style: normal;\n  font-weight: 400;\n  font-size: clamp(3rem, 6vw, 5.5rem);\n  line-height: 0.95;\n  color: rgba(255, 255, 255, 0.92);\n  margin: 0 0 26px;\n  text-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);\n  text-transform: none;\n  letter-spacing: normal;\n}\n\n.mh2v2-hero__title::first-letter {\n  font-feature-settings: \"init\" 1;\n}\n\n.mh2v2-program-card.mustard .mh2v2-program-card__overlay {\n  background: #d59d55;\n}\n\n.mh2v2-program-card.coral .mh2v2-program-card__overlay {\n  background: var(--coral);\n}\n\n.mh2v2-program-card.pink .mh2v2-program-card__overlay {\n  background: var(--pink);\n}\n\na.mh2v2-happening-card {\n  text-decoration: none;\n  color: #fff;\n}\n\n.mh2v2-founder-panel > a {\n  display: block;\n}\n\n.mh2v2-founder-panel > a img {\n  width: 100%;\n}\n\n.mh2v2-page {\n  width: 100%;\n  overflow-x: hidden;\n}\n\n.mh2v2-section-light {\n  background: var(--light);\n}\n\n.mh2v2-section-cream {\n  background: var(--cream);\n}\n\n.mh2v2-section-mustard {\n  background: #d5b95a;\n}\n\n.mh2v2-section-charcoal {\n  background: var(--charcoal);\n}\n\n/* Typography roles: see homepageV2Foundation.css */\n\n.mh2v2-section-title--center {\n  text-align: center;\n}\n\n.mh2v2-section-title--light {\n  color: var(--white);\n}\n\n.mh2v2-script,\n.mh2v2-now-card__overlay h4,\n.mh2v2-program-card__overlay h4,\n.mh2v2-testimonial__content h4,\n.mh2v2-category-card__overlay h5,\n.mh2v2-collective-info h4,\n.mh2v2-about-founder__caption h4,\n.mh2v2-membership-tier h4 {\n  font-family: var(--mh-font-display);\n  font-weight: 400;\n}\n\n.mh2v2-script {\n  color: #de7d86;\n  text-align: center;\n  font-size: clamp(2rem, 4vw, 3.6rem);\n  line-height: 1.08;\n  max-width: 950px;\n  margin: 0 auto 14px;\n}\n\n.mh2v2-copy--center {\n  text-align: center;\n  max-width: 820px;\n  margin: 0 auto;\n}\n\n.mh2v2-pill {\n  border: none;\n  border-radius: 999px;\n  padding: 13px 26px;\n  cursor: pointer;\n  background: var(--gold);\n  color: #fff;\n  font-weight: 700;\n  box-shadow: var(--shadow);\n  transition:\n    transform var(--transition-base),\n    box-shadow var(--transition-base),\n    color var(--transition-fast);\n}\n\n.mh2v2-pill:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-hover);\n}\n\n.mh2v2-pill:active {\n  transform: translateY(0);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\n}\n\n.mh2v2-pill:focus-visible {\n  outline: var(--focus-ring);\n  outline-offset: var(--focus-ring-offset);\n}\n\n.mh2v2-pill--small {\n  padding: 10px 18px;\n  font-size: 0.9rem;\n}\n\n.mh2v2-pill--region {\n  min-width: 220px;\n  color: #fff;\n  box-shadow: none;\n  transition: transform var(--transition-base), opacity var(--transition-fast);\n}\n\n.mh2v2-pill--region:hover {\n  transform: translateY(-2px);\n  opacity: 0.95;\n}\n\n.mh2v2-pill--region:active {\n  transform: translateY(0);\n}\n\n.mh2v2-pill--region:focus-visible {\n  outline: var(--focus-ring);\n  outline-offset: var(--focus-ring-offset);\n}\n\n.mh2v2-pill--gold {\n  background: var(--gold);\n  color: #fff;\n}\n\na.mh2v2-pill,\na.mh2v2-inline-btn,\na.mh2v2-category-link {\n  text-decoration: none;\n  display: inline-block;\n  text-align: center;\n}\n\n.mh2v2-page .coral {\n  background: var(--coral);\n}\n\n.mh2v2-page .mustard {\n  background: #d59d55;\n}\n\n.mh2v2-page .pink {\n  background: var(--pink);\n}\n\n.mh2v2-page .teal {\n  background: var(--teal);\n}\n\n.mh2v2-page .salmon {\n  background: var(--salmon);\n}\n\n.mh2v2-page .mint {\n  background: var(--mint);\n}\n\n.mh2v2-teal-text {\n  color: var(--teal);\n}\n\n.mh2v2-inline-btn {\n  border: none;\n  background: #ef8b6a;\n  color: white;\n  border-radius: 999px;\n  padding: 8px 14px;\n  font-size: 0.86rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition:\n    transform var(--transition-fast),\n    opacity var(--transition-fast),\n    background-color var(--transition-fast);\n}\n\n.mh2v2-inline-btn:hover {\n  transform: translateY(-1px);\n  opacity: 0.95;\n  background-color: #e87a58;\n}\n\n.mh2v2-inline-btn:active {\n  transform: translateY(0);\n}\n\n.mh2v2-inline-btn:focus-visible {\n  outline: var(--focus-ring);\n  outline-offset: var(--focus-ring-offset);\n}\n\n.mh2v2-link-row {\n  display: block;\n  text-align: center;\n  font-weight: 700;\n  color: var(--text);\n  transition: color var(--transition-fast);\n}\n\n.mh2v2-link-row:hover {\n  color: var(--teal);\n}\n\n.mh2v2-link-row:focus-visible {\n  outline: var(--focus-ring);\n  outline-offset: var(--focus-ring-offset);\n  border-radius: 2px;\n}\n\n.mh2v2-link-row--light {\n  color: var(--white);\n}\n\n.mh2v2-link-row--light:hover {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n/* Header / nav: see components/navigation/MamahoodMarketingHeader.css */\n\n/* Hero */\n.mh2v2-hero {\n  position: relative;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: var(--mh2-space-2xl) var(--mh2-container-gutter);\n  min-height: 620px;\n\n  background: #d9e6e3 url(\"/static/img/IMAGES/BANNERS/homepage_banner_mobile.png\") center / cover no-repeat;\n\n  display: flex;\n  align-items: center;\n}\n\n.mh2v2-hero__overlay {\n  position: absolute;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  text-align: center;\n  padding: 32px;\n  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.08));\n}\n\n/* .mh2v2-hero__title: see MamahoodHeroTitle.css */\n\n.mh2v2-region-row {\n  margin-top: var(--mh2-gap-lg);\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.mh2v2-happening-grid {\n  margin-top: var(--mh2-space-xl);\n  display: grid;\n  grid-template-columns: 1.3fr 0.9fr;\n  align-items: start;\n}\n\n.mh2v2-happening-list {\n  display: grid;\n}\n\n.mh2v2-happening-card {\n  display: grid;\n  grid-template-columns: 56px 1fr 48px;\n  gap: var(--mh2-space-md);\n  align-items: center;\n  padding: var(--mh2-space-md) var(--mh2-space-md);\n  color: #fff;\n}\n\n.mh2v2-happening-card:focus-within {\n  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);\n}\n\n.mh2v2-happening-card__icon {\n  font-size: 1.5rem;\n  text-align: center;\n}\n\n.mh2v2-happening-card__body h4 {\n  margin: 0 0 4px;\n  font-size: 1.15rem;\n}\n\n.mh2v2-happening-card__body p {\n  margin: 0;\n  font-size: 0.95rem;\n  line-height: 1.4;\n}\n\n.mh2v2-happening-card__arrow {\n  justify-self: end;\n  width: 36px;\n  height: 36px;\n  border: 1px solid rgba(255, 255, 255, 0.75);\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  font-size: 1.1rem;\n  transition: transform var(--transition-fast);\n}\n\n.mh2v2-happening-card:hover .mh2v2-happening-card__arrow {\n  transform: translateX(3px);\n}\n\n.mh2v2-membership-box {\n  background: #fff;\n  border-radius: var(--mh2-card-radius-lg);\n  padding: var(--mh2-space-lg) var(--mh2-space-lg) var(--mh2-gap-lg);\n}\n\n.mh2v2-membership-box:hover {\n  box-shadow: var(--shadow-hover);\n}\n\n.mh2v2-membership-tier {\n  text-align: center;\n}\n\n.mh2v2-membership-tier h4 {\n  font-size: 2rem;\n  margin: 16px 0 10px;\n  line-height: 1;\n}\n\n.mh2v2-membership-tier p {\n  margin: 0 auto 16px;\n  color: var(--muted);\n  max-width: 320px;\n  line-height: 1.5;\n}\n\n.mh2v2-membership-divider {\n  height: 1px;\n  background: #ddd;\n  margin: 24px 0;\n}\n\n.mh2v2-round-logo {\n  width: 78px;\n  height: 78px;\n  margin: 0 auto;\n  border-radius: 50%;\n  background: var(--mint);\n  color: #fff;\n  display: grid;\n  place-items: center;\n  font-family: var(--mh-font-display);\n  font-size: 2rem;\n  font-weight: 400;\n}\n\n.mh2v2-round-logo--small {\n  font-size: 1.2rem;\n}\n\n.mh2v2-round-logo--xl {\n  width: 102px;\n  height: 102px;\n  font-size: 1.5rem;\n}\n\n.mh2v2-story-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.mh2v2-story-card {\n  background: #fff4df;\n  overflow: hidden;\n}\n\n.mh2v2-story-card img {\n  height: 190px;\n}\n\n.mh2v2-story-card:hover img {\n  transform: scale(1.03);\n}\n\n.mh2v2-story-card__content {\n  padding: var(--mh2-card-padding);\n  display: flex;\n  justify-content: space-between;\n  gap: var(--mh2-gap-sm);\n  align-items: center;\n}\n\n.mh2v2-story-card__content p {\n  margin: 0;\n  font-size: 0.96rem;\n  line-height: 1.35;\n}\n\n/* Now */\n.mh2v2-now-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.mh2v2-now-card {\n  overflow: hidden;\n  position: relative;\n  min-height: 430px;\n}\n\n.mh2v2-now-card img {\n  height: 430px;\n}\n\n.mh2v2-now-card:hover img {\n  transform: scale(1.04);\n}\n\n.mh2v2-now-card__overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(to top, rgba(111, 159, 154, 0.85), rgba(0, 0, 0, 0.1));\n  color: #fff;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  padding: var(--mh2-space-lg);\n}\n\n.mh2v2-now-card__overlay h4 {\n  font-size: 3rem;\n  line-height: 0.9;\n  margin: 0 0 18px;\n}\n\n.mh2v2-now-card__footer {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 14px;\n}\n\n.mh2v2-now-card__footer p {\n  margin: 0;\n  font-size: 0.95rem;\n  max-width: 200px;\n}\n\n.mh2v2-program-list {\n  display: grid;\n}\n\n.mh2v2-program-card {\n  --program-image-position: 50% 40%;\n  --program-image-scale: 1;\n\n  position: relative;\n  min-height: 260px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.mh2v2-program-card__media {\n  position: relative;\n  height: 150px;\n  overflow: hidden;\n}\n\n.mh2v2-program-card__media img {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n  object-position: var(--program-image-position);\n  transform: scale(var(--program-image-scale));\n}\n\n.mh2v2-program-card__overlay {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 22px 28px;\n  text-align: center;\n  color: white;\n}\n\n.mh2v2-program-card__overlay h4 {\n  font-size: clamp(2.2rem, 4vw, 4.6rem);\n  line-height: 0.9;\n  margin: 0;\n  text-shadow: 0 4px 18px rgba(0, 0, 0, 0.2);\n}\n\n.mh2v2-program-card__overlay p {\n  margin: var(--mh2-space-sm) 0 0;\n  font-size: var(--mh2-size-body-sm);\n  max-width: 760px;\n  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n}\n\n.mh2v2-testimonial-list {\n  display: grid;\n}\n\n.mh2v2-testimonial {\n  --testimonial-image-position: 50% 40%;\n  --testimonial-image-scale: 1;\n\n  display: grid;\n  grid-template-columns: 1fr 1.45fr;\n  overflow: hidden;\n  background: white;\n}\n\n.mh2v2-testimonial.reverse {\n  grid-template-columns: 1.45fr 1fr;\n}\n\n.mh2v2-testimonial.reverse .mh2v2-testimonial__media {\n  order: 2;\n}\n\n.mh2v2-testimonial__media {\n  position: relative;\n  height: 100%;\n  min-height: 330px;\n  overflow: hidden;\n}\n\n.mh2v2-testimonial__media img {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n  object-position: var(--testimonial-image-position);\n  transform: scale(var(--testimonial-image-scale));\n  transform-origin: center center;\n  transition: transform var(--transition-slow);\n}\n\n.mh2v2-testimonial:hover .mh2v2-testimonial__media img {\n  transform: scale(calc(var(--testimonial-image-scale) * 1.02));\n}\n\n.mh2v2-testimonial__content {\n  padding: var(--mh2-space-xl) var(--mh2-space-lg);\n  color: white;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.mh2v2-testimonial__content.teal {\n  background: var(--teal);\n}\n\n.mh2v2-testimonial__content.mustard {\n  background: #d3b357;\n  color: #2f2b2f;\n}\n\n.mh2v2-testimonial__content.coral {\n  background: var(--coral);\n}\n\n.mh2v2-testimonial__content h4 {\n  font-size: clamp(2rem, 3.3vw, 3.2rem);\n  line-height: 1;\n  margin: 0 0 18px;\n}\n\n.mh2v2-testimonial__content p {\n  font-size: var(--mh2-size-body);\n  line-height: var(--mh2-line-body);\n  margin: 0 0 var(--mh2-gap-sm);\n  opacity: 0.95;\n}\n\n.mh2v2-testimonial__content strong,\n.mh2v2-testimonial__content span {\n  display: block;\n  font-size: 1.2rem;\n  margin-top: 4px;\n}\n\n/* M List */\n.mh2v2-mlist-hero {\n  position: relative;\n  min-height: 260px;\n}\n\n.mh2v2-mlist-hero__badge {\n  position: absolute;\n  right: 60px;\n  top: 24px;\n  width: 220px;\n  height: 220px;\n  border: 3px dashed rgba(255, 255, 255, 0.8);\n  border-radius: 50%;\n  color: white;\n  display: grid;\n  place-items: center;\n  font-family: var(--mh-font-display);\n  font-size: 2rem;\n  background: rgba(151, 112, 72, 0.45);\n}\n\n.mh2v2-center-actions {\n  display: flex;\n  justify-content: center;\n  gap: 14px;\n  flex-wrap: wrap;\n  margin: 18px 0 28px;\n}\n\n.mh2v2-category-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.mh2v2-category-card {\n  background: white;\n  overflow: hidden;\n}\n\n.mh2v2-category-card img {\n  height: 240px;\n}\n\n.mh2v2-category-card:hover img {\n  transform: scale(1.03);\n}\n\n.mh2v2-category-card__overlay {\n  position: relative;\n  margin-top: -120px;\n  color: #fff;\n  padding: var(--mh2-space-lg) var(--mh2-space-md);\n  min-height: 120px;\n  background: var(--mh2-overlay-gradient);\n}\n\n.mh2v2-category-card__overlay h5 {\n  font-size: 3rem;\n  line-height: 0.88;\n  margin: 0 0 14px;\n}\n\n.mh2v2-category-links {\n  display: grid;\n  gap: 10px;\n  padding: 16px 14px 18px;\n}\n\n.mh2v2-category-link {\n  border: none;\n  border-radius: 999px;\n  padding: 12px 16px;\n  background: var(--gold);\n  color: white;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform var(--transition-fast), box-shadow var(--transition-fast);\n}\n\n.mh2v2-category-link:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow);\n}\n\n.mh2v2-category-link:active {\n  transform: translateY(0);\n}\n\n.mh2v2-category-link:focus-visible {\n  outline: var(--focus-ring);\n  outline-offset: var(--focus-ring-offset);\n}\n\n/* Collective */\n.mh2v2-collective-grid {\n  display: grid;\n  grid-template-columns: 1fr 1.15fr;\n  align-items: start;\n}\n\n.mh2v2-collective-info h4 {\n  font-size: clamp(2.2rem, 4vw, 4rem);\n  line-height: 0.9;\n  margin: 0 0 18px;\n  max-width: 540px;\n}\n\n.mh2v2-collective-info p {\n  font-size: 1.05rem;\n  line-height: 1.6;\n  color: var(--muted);\n  max-width: 430px;\n}\n\n.mh2v2-quote-chip {\n  background: var(--mint);\n  color: white;\n  border-radius: 24px;\n  padding: 24px 26px;\n  margin: 28px 0 0;\n  font-size: 1.6rem;\n  font-family: var(--mh-font-display);\n  line-height: 1.1;\n}\n\n.mh2v2-quote-chip span {\n  display: block;\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 0.95rem;\n  margin-top: 10px;\n}\n\n.mh2v2-founder-panel {\n  background: var(--cream);\n  border-radius: var(--mh2-card-radius-lg);\n  padding: var(--mh2-space-lg);\n}\n\n.mh2v2-founder-panel img {\n  height: 360px;\n}\n\n.mh2v2-founder-panel__body {\n  display: grid;\n  grid-template-columns: 140px 1fr;\n  gap: 18px;\n  padding: 18px 4px 6px;\n}\n\n.mh2v2-founder-brand {\n  font-size: 2rem;\n  font-family: var(--mh-font-display);\n}\n\n.mh2v2-founder-panel__body h5 {\n  font-size: 2.2rem;\n  margin: 0 0 8px;\n  font-family: var(--mh-font-display);\n}\n\n.mh2v2-founder-panel__body p {\n  margin: 0 0 8px;\n  line-height: 1.5;\n  color: var(--muted);\n}\n\n/* About */\n.mh2v2-about-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  align-items: center;\n}\n\n.mh2v2-about-founder img {\n  height: 420px;\n}\n\n.mh2v2-about-founder__caption {\n  text-align: center;\n  color: #fff;\n  margin-top: -70px;\n  position: relative;\n  z-index: 1;\n  padding-bottom: 20px;\n}\n\n.mh2v2-about-founder__caption h4 {\n  font-size: 2.5rem;\n  margin: 0 0 6px;\n}\n\n.mh2v2-about-founder__caption p {\n  margin: 0;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.mh2v2-region-row--compact {\n  margin-top: 8px;\n}\n\n.mh2v2-region-row--compact .mh2v2-pill--region {\n  min-width: 180px;\n  font-size: 0.85rem;\n}\n\n.mh2v2-about-copy {\n  color: #fff;\n}\n\n.mh2v2-about-copy p {\n  line-height: var(--mh2-line-body);\n  color: rgba(255, 255, 255, 0.9);\n  font-size: var(--mh2-size-body);\n}\n\n/* Footer */\n.mh2v2-footer {\n  background: #f3f1ef;\n  padding: 36px 0 50px;\n}\n\n.mh2v2-footer__grid {\n  display: grid;\n  grid-template-columns: 1fr auto 1.2fr;\n  align-items: start;\n}\n\n.mh2v2-footer__links {\n  display: grid;\n  gap: 10px;\n  text-transform: uppercase;\n  font-size: 0.84rem;\n  letter-spacing: 0.08em;\n  font-weight: 700;\n}\n\n.mh2v2-footer__links a {\n  color: var(--text);\n  text-decoration: none;\n  transition: color var(--transition-fast);\n}\n\n.mh2v2-footer__links a:hover {\n  color: var(--teal);\n}\n\n.mh2v2-footer__links a:focus-visible {\n  outline: var(--focus-ring);\n  outline-offset: var(--focus-ring-offset);\n  border-radius: 2px;\n}\n\n.mh2v2-footer__brand {\n  display: grid;\n  justify-items: center;\n  gap: 12px;\n}\n\n.mh2v2-newsletter h4 {\n  margin: 0 0 12px;\n  letter-spacing: 0.18em;\n  font-size: 0.95rem;\n  text-transform: uppercase;\n}\n\n.mh2v2-newsletter__row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.mh2v2-newsletter input {\n  width: 100%;\n  padding: 12px 14px;\n  margin-bottom: 12px;\n  border: 1px solid #cfc6bf;\n  background: #fff;\n}\n\n/* Reduced motion */\n@media (prefers-reduced-motion: reduce) {\n  .mh2v2-pill,\n  .mh2v2-pill--region,\n  .mh2v2-inline-btn,\n  .mh2v2-happening-card,\n  .mh2v2-happening-card__arrow,\n  .mh2v2-story-card,\n  .mh2v2-story-card img,\n  .mh2v2-now-card,\n  .mh2v2-now-card img,\n  .mh2v2-program-card,\n  .mh2v2-program-card__media img,\n  .mh2v2-testimonial,\n  .mh2v2-testimonial__media img,\n  .mh2v2-category-card,\n  .mh2v2-category-card img,\n  .mh2v2-category-link,\n  .mh2v2-membership-box,\n  .mh2v2-socials span {\n    transition: none;\n  }\n\n  .mh2v2-pill:hover,\n  .mh2v2-pill--region:hover,\n  .mh2v2-inline-btn:hover,\n  .mh2v2-happening-card:hover,\n  .mh2v2-story-card:hover,\n  .mh2v2-now-card:hover,\n  .mh2v2-program-card:hover,\n  .mh2v2-testimonial:hover,\n  .mh2v2-category-card:hover,\n  .mh2v2-category-link:hover,\n  .mh2v2-socials span:hover {\n    transform: none;\n  }\n\n  .mh2v2-happening-card:hover .mh2v2-happening-card__arrow {\n    transform: none;\n  }\n\n  .mh2v2-story-card:hover img,\n  .mh2v2-now-card:hover img,\n  .mh2v2-program-card:hover .mh2v2-program-card__media img,\n  .mh2v2-category-card:hover img,\n  .mh2v2-testimonial:hover .mh2v2-testimonial__media img {\n    transform: none;\n  }\n}\n\n/* Responsive */\n@media (max-width: 1100px) {\n  .mh2v2-happening-grid,\n  .mh2v2-collective-grid,\n  .mh2v2-about-grid,\n  .mh2v2-footer__grid {\n    grid-template-columns: 1fr;\n  }\n\n  .mh2v2-story-grid,\n  .mh2v2-now-grid,\n  .mh2v2-category-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .mh2v2-testimonial,\n  .mh2v2-testimonial.reverse {\n    grid-template-columns: 1fr;\n  }\n\n  .mh2v2-testimonial.reverse .mh2v2-testimonial__media {\n    order: 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .mh2v2-hero {\n    min-height: 480px;\n    height: 480px;\n  }\n\n  .mh2v2-story-grid,\n  .mh2v2-now-grid,\n  .mh2v2-category-grid,\n  .mh2v2-newsletter__row,\n  .mh2v2-founder-panel__body {\n    grid-template-columns: 1fr;\n  }\n\n  .mh2v2-category-card__overlay h5,\n  .mh2v2-now-card__overlay h4,\n  .mh2v2-testimonial__content h4,\n  .mh2v2-collective-info h4 {\n    font-size: 2.2rem;\n  }\n\n  .mh2v2-program-card__overlay h4 {\n    font-size: 2rem;\n  }\n\n  .mh2v2-mlist-hero__badge {\n    width: 150px;\n    height: 150px;\n    right: 18px;\n    top: 18px;\n    font-size: 1.3rem;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
